// GET_DISCOVERY_REVIEWS
export const GET_DISCOVERY_REVIEWS = 'GET_DISCOVERY_REVIEWS';
export const GET_DISCOVERY_REVIEWS_SUCCESS = 'GET_DISCOVERY_REVIEWS_SUCCESS';
export const GET_DISCOVERY_REVIEWS_FAILED = 'GET_DISCOVERY_REVIEWS_FAILED';
export const CLEANUP_DISCOVER_REVIEWS = 'CLEANUP_DISCOVER_REVIEWS';

// GET_DISCOVERY_REVIEW_DETAILS
export const GET_DISCOVERY_REVIEW_DETAILS = 'GET_DISCOVERY_REVIEW_DETAILS';
export const GET_DISCOVERY_REVIEW_DETAILS_SUCCESS = 'GET_DISCOVERY_REVIEW_DETAILS_SUCCESS';
export const GET_DISCOVERY_REVIEW_DETAILS_FAILED = 'GET_DISCOVERY_REVIEW_DETAILS_FAILED';
export const CLEANUP_DISCOVER_REVIEW_DETAILS = 'CLEANUP_DISCOVER_REVIEW_DETAILS';

// DELETE_DISCOVERY_REVIEW
export const DELETE_DISCOVERY_REVIEW = 'DELETE_DISCOVERY_REVIEW';
export const DELETE_DISCOVERY_REVIEW_SUCCESS = 'DELETE_DISCOVERY_REVIEW_SUCCESS';
export const DELETE_DISCOVERY_REVIEW_FAILED = 'DELETE_DISCOVERY_REVIEW_FAILED';
